import(/* webpackMode: "eager" */ "/app/src/contents/attendance/index.tsx")